// Removed unused React import
import AuthLayout from '../components/AuthLayout';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
import { useEffect, useState } from 'react';

export default function CurrentUserPage() {
  const [user, setUser] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/current-user/`)
      .then(res => setUser(res.data))
      .catch(err => {
        if (err.response?.status === 401) {
          setError('Not logged in');
        } else {
          setError(err.response?.data?.detail || 'Error fetching user info');
        }
      });
  }, []);

  return (
    <AuthLayout title="Current User" description="Info about the logged-in user.">
      {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      {user ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div><strong>ID:</strong> {user.id}</div>
          <div><strong>Username:</strong> {user.username}</div>
          <div><strong>Email:</strong> {user.email}</div>
        </div>
      ) : !error && <div>Loading...</div>}
    </AuthLayout>
  );
}
